import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';
import { DynamicDialogRef } from 'primeng/dynamicdialog';

/**
 * Small modal shown by `blockedAccessGuard` when the user tries to open the
 * "new test" page after their trial has expired (MVP-10 / MVP-9 follow-up).
 * The soft-block is scoped to the new-test route only — everywhere else
 * (dashboard, test list, settings) remains reachable so the user can still
 * review their data and manage their account.
 *
 * The primary CTA opens the shared `SalesContactModalComponent` so the user
 * can reach out to upgrade. We close this dialog first so the contact modal
 * owns the focus cleanly.
 */
@Component({
  standalone: false,
  selector: 'app-trial-expired-dialog',
  templateUrl: './trial-expired-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TrialExpiredDialogComponent {
  showSalesContact = false;

  constructor(
    private dialogRef: DynamicDialogRef,
    private cdr: ChangeDetectorRef
  ) {}

  openSalesContact(): void {
    // Render the shared sales-contact modal inline (its own p-dialog uses
    // appendTo="body" so it escapes any wrapper). Using DialogService.open
    // here would double-wrap the p-dialog inside a DynamicDialog and collapse
    // it to the host's natural width.
    this.showSalesContact = true;
    this.cdr.markForCheck();
  }

  onSalesClosed(): void {
    this.showSalesContact = false;
    this.cdr.markForCheck();
  }

  onSalesSubmitted(): void {
    this.showSalesContact = false;
    this.dialogRef.close();
  }

  close(): void {
    this.dialogRef.close();
  }
}
